export enum ActionTypes {
    FetchUserFavorites = "FAVORITES_FETCH_USER",
    FetchUserFavoritesPending = "FAVORITES_FETCH_USER_PENDING",
    FetchUserFavoritesRejected = "FAVORITES_FETCH_USER_REJECTED",
    FetchUserFavoritesFulfilled = "FAVORITES_FETCH_USER_FULFILLED",
}
